'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var c = _interopRequireWildcard(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _reactisLoader = require('reactis-loader');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reduxModulesProfile = require('../../redux/modules/profile');

var actions = _interopRequireWildcard(_reduxModulesProfile);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _components = {
	_$Form: {
		displayName: 'Form'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Form = (function (_Component) {
	_inherits(Form, _Component);

	_createClass(Form, null, [{
		key: 'contextTypes',
		value: {
			store: _react2['default'].PropTypes.object
		},
		enumerable: true
	}]);

	function Form(props) {
		_classCallCheck(this, _Form);

		_Component.call(this, props);
		this.schema = {
			oldpassword: {
				'class': _reactisInputs.TextInput,
				type: 'password',
				label: 'Aktuální heslo',
				autoComplete: 'off',
				rules: {
					presence: { message: 'Zadejte aktuální heslo!' }
				}
			},
			password: {
				'class': _reactisInputs.TextInput,
				type: 'password',
				label: 'Nové heslo',
				autoComplete: 'off',
				rules: {
					presence: { message: 'Zadejte nové heslo!' }
				}
			},
			passwordConfirm: {
				'class': _reactisInputs.TextInput,
				type: 'password',
				label: 'Heslo pro kontrolu',
				autoComplete: 'off',
				rules: {
					equality: {
						attribute: 'password',
						message: 'Hesla se musejí shodovat!'
					}
				}
			}
		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Form.prototype.save = function save() {
		var _this = this;

		var close = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

		var errors = this.refs.form.getWrappedInstance().validate();
		if (errors) {
			this.displayErrors(errors);
		} else {
			var data = _extends({}, this.form.getValues().toJS());
			this.props.actions.save(data).then(function (action) {
				if (action.error) {
					if (action.error.code == 1001) {
						var _errors = JSON.parse(action.error.message);
						_this.displayErrors(_errors);
					} else {
						if (action.error.message) {
							alert(action.error.message);
						}
					}
				} else {
					_this.form.reset();
				}
			});
		}
	};

	Form.prototype.displayErrors = function displayErrors(errors) {
		var messages = [];
		_Object$keys(errors).forEach(function (key) {
			if (errors[key].childs) {
				errors[key].childs.forEach(function (child) {
					_Object$keys(child.errors).forEach(function (key2) {
						messages.push(child.errors[key2][0]);
					});
				});
			} else {
				messages.push(errors[key][0]);
			}
		});
		var alert = new _reactisModal.AlertWindow('Chyba formuláře', messages.map(function (m) {
			return _react2['default'].createElement(
				'span',
				{ key: m },
				m,
				_react2['default'].createElement('br', null)
			);
		}));
		alert.show(this.context.store.dispatch);
	};

	Form.prototype.render = function render() {
		var _this2 = this;

		return _react2['default'].createElement(
			'div',
			{ className: 'tdidocument' },
			_react2['default'].createElement(_reactDocumentTitle2['default'], { title: 'Můj profil' }),
			_react2['default'].createElement(
				'div',
				{ className: 'page-header content-group' },
				_react2['default'].createElement(
					'div',
					{ className: 'page-header-content' },
					_react2['default'].createElement(
						'h5',
						null,
						_react2['default'].createElement('i', { className: 'icon-user position-left' }),
						_react2['default'].createElement(
							'span',
							{ className: 'text-semibold' },
							'Můj profil'
						)
					)
				)
			),
			_react2['default'].createElement(
				'div',
				{ className: 'panel', style: { paddingBottom: 0 } },
				_react2['default'].createElement(
					'div',
					{ style: { padding: 20 } },
					_react2['default'].createElement(
						'div',
						{ style: { position: 'relative' } },
						_react2['default'].createElement(
							_reactisForms.RxForm,
							{ ref: 'form', form: this.form, id: 'profile' },
							_react2['default'].createElement(
								'div',
								{ className: 'row' },
								_react2['default'].createElement(
									'div',
									{ className: 'col-md-6' },
									_react2['default'].createElement(
										'table',
										{ className: 'form' },
										_react2['default'].createElement(
											'tbody',
											null,
											_Object$keys(this.schema).map(function (key) {
												return _react2['default'].createElement(_reactisForms.FormRow, { key: key, visible: _this2.schema[key].visible, name: key, labelWidth: '135' });
											}),
											_react2['default'].createElement(
												'tr',
												{ className: 'buttons' },
												_react2['default'].createElement('td', { style: { width: 135 } }),
												_react2['default'].createElement(
													'td',
													null,
													_react2['default'].createElement(_reactisLoader.LoadingButton, {
														loading: !!(this.props.form && this.props.form.get('saving')),
														title: 'Uložit',
														onClick: function () {
															return _this2.save();
														}
													})
												)
											)
										)
									)
								)
							)
						)
					)
				)
			)
		);
	};

	var _Form = Form;
	Form = _wrapComponent('_$Form')(Form) || Form;
	Form = _reactRedux.connect(function (state, props) {
		return {
			//rxform: state.forms.get('profile')
			form: state.profile
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(actions, dispatch) };
	})(Form) || Form;
	return Form;
})(_componentsComponent2['default']);

exports['default'] = Form;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/User/Profile.js
 ** module id = 979
 ** module chunks = 2
 **/